import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartRecommendationProductEntityParams {
  product_id: number;
  inventory_id: number;
  order_id: number;
  distributor_id: number;
}
export class CartRecommendationProductEntity extends BaseEntityClass {
  product_id: number;
  inventory_id: number;
  order_id: number;
  distributor_id: number;
  constructor(params: CartRecommendationProductEntityParams) {
    super();
    this.type = "cart_recommendation_product";
    this.product_id = params.product_id;
    this.inventory_id = params.inventory_id;
    this.entity_version = 2;
    this.order_id = params.order_id;
    this.distributor_id = params.distributor_id;
  }
}
